import { CampaignCompletionState } from '@urbanx/agx-ui-components';
import { Tabs } from 'types/Tabs';

export enum CampaignStageAction {
  Restore = 'Restore',
  RevertToCurrent = 'RevertToCurrent',
  MarkAsUnderContract = 'MarkAsUnderContract',
  MarkAsSold = 'MarkAsSold',
  Archive = 'Archive',
  Withdraw = 'Withdraw',
}

export interface CampaignActionRequest {
  campaignId: string;
  campaignAction: CampaignStageAction;
}

export interface CampaignActionResponse {
  campaignId: string;
  actionSuccessful: boolean;
  completionState: CampaignCompletionState;
}
